(function () {
  function publish(eventName, payload) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload || {});
    }
  }

  // Rebuy's item payload has no currency field -- Shopify exposes the
  // store's active currency globally on every storefront page instead.
  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined;
  }

  // Rebuy's line-item payload is the full Shopify cart-line object plus a
  // nested product (variants/images/collections/etc.) -- confirmed via a real
  // fired event to be many KB. GA4 event params have strict size limits, so
  // pull out just what's useful for reporting instead of forwarding it whole.
  // Rebuy's cart-line schema matches Shopify's classic /cart.js line format:
  // price/line_price are in cents.
  function summarizeItem(item) {
    if (!item) return undefined;
    return {
      item_id: String(item.variant_id || item.id || ''),
      item_name: item.product_title || item.title || '',
      item_variant: item.variant_title || undefined,
      item_brand: item.vendor || undefined,
      item_category: item.product_type || undefined,
      sku: item.sku || undefined,
      price: typeof item.price === 'number' ? item.price / 100 : undefined,
      quantity: item.quantity,
    };
  }

  // Rebuy Smart Cart events -> custom Shopify analytics events.
  // Reference: https://developers.rebuyengine.com/reference/smart-cart-event-listeners/
  // These interactions go through /cart/change.js, which Shopify does not
  // auto-instrument, so nothing reaches GA4 without republishing them here.

  // IMPORTANT: publish this as "cart_drawer_viewed", NOT "cart_viewed" --
  // "cart_viewed" is one of Shopify's own reserved standard Customer Event
  // names. Publishing a custom payload under a reserved name silently failed
  // to reach the custom pixel no matter how it was triggered (event listener,
  // polling, manual console call, bubble- and capture-phase clicks all
  // failed identically), while every non-colliding custom name below worked
  // immediately. That ruled out timing/trust theories -- the name itself was
  // the problem.
  // rebuy:smartcart.show fires on every cart re-render while open, not just
  // the initial open -- confirmed live: it re-fired alongside both a quantity
  // change and an item removal in the same open session. Track open/closed
  // state ourselves and only publish on a genuine closed->open transition.
  var cartDrawerIsOpen = false;
  document.addEventListener('rebuy:smartcart.show', function () {
    if (!cartDrawerIsOpen) {
      publish('cart_drawer_viewed', { source: 'rebuy' });
    }
    cartDrawerIsOpen = true;
  });
  document.addEventListener('rebuy:smartcart.hide', function () {
    cartDrawerIsOpen = false;
  });

  document.addEventListener('rebuy:smartcart.line-item-increase', function (event) {
    publish('cart_quantity_updated', {
      direction: 'increase',
      item: summarizeItem(event.detail && event.detail.item),
      currency: getCurrency(),
      source: 'rebuy',
    });
  });

  document.addEventListener('rebuy:smartcart.line-item-decrease', function (event) {
    publish('cart_quantity_updated', {
      direction: 'decrease',
      item: summarizeItem(event.detail && event.detail.item),
      currency: getCurrency(),
      source: 'rebuy',
    });
  });

  document.addEventListener('rebuy:smartcart.line-item-removed', function (event) {
    publish('cart_item_removed', {
      item: summarizeItem(event.detail && event.detail.item),
      currency: getCurrency(),
      source: 'rebuy',
    });
  });

  // Recharge's PDP subscription widget (Subscription Widget v2, a theme
  // app-extension block -- not the legacy JS widget, which has a documented
  // but different event API we can't rely on here). No documented event API
  // found for this version, but the actual purchase-option control is a
  // plain radio input, so a standard change listener works without needing
  // any Recharge-specific hook.
  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('input[name="purchaseOption"]')) return;
    publish('pdp_purchase_option_selected', { type: event.target.value });
  });

  // The above only signals engagement with the toggle, not what actually gets
  // added to cart -- someone could flip it back and forth before clicking Add
  // to Cart. Reconcile by reading the actual selling_plan field (the one that
  // determines whether the resulting cart line is a subscription) at the
  // moment of the real add-to-cart click. Confirmed live: empty string for
  // one-time, a real selling plan id for subscription.
  // Scoped to the specific form the clicked button belongs to, not a global
  // document.querySelector -- a page can have more than one product form
  // (e.g. a quick-add modal alongside the main PDP form), and we want the
  // variant/selling_plan/quantity that actually match this click, not
  // whichever form happens to be first in the document.
  document.addEventListener('click', function (event) {
    var submitButton = event.target.closest('.product-form__submit');
    if (!submitButton) return;
    var form = submitButton.closest('form');
    if (!form) return;

    var sellingPlanField = form.querySelector('[name="selling_plan"]');
    var sellingPlanId = sellingPlanField && sellingPlanField.value;
    var variantField = form.querySelector('[name="id"]');
    var quantityField = form.querySelector('[name="quantity"]');

    publish('pdp_add_to_cart_click', {
      purchase_option: sellingPlanId ? 'subscription' : 'one_time',
      selling_plan_id: sellingPlanId || undefined,
      item_id: variantField ? variantField.value : undefined,
      quantity: quantityField ? Number(quantityField.value) : 1,
    });
  });

  // Accelerated checkout buttons (Shop Pay / Apple Pay / PayPal, etc).
  // These render Shopify-hosted widgets we can't inspect internally, but a click
  // anywhere in their wrapper -- outside the normal add-to-cart/checkout button --
  // means the customer used an accelerated path that skips checkout_started.
  document.addEventListener('click', function (event) {
    var pdpWrapper = event.target.closest('.product-form__buttons');
    if (pdpWrapper && !event.target.closest('.product-form__submit')) {
      publish('accelerated_checkout_click', { location: 'pdp' });
      return;
    }

    var cartWrapper = event.target.closest('.cart__dynamic-checkout-buttons');
    if (cartWrapper) {
      publish('accelerated_checkout_click', { location: 'cart' });
    }
  });
})();
